export const stuffData = [
  "music 🎵",
  "traveling ✈️",
  "gardening 🥦",
  "unique experiences 💡",
  "building stuff 🛠️",
];
